export enum SentryTag {
  ERROR_CODE = 'error_code'
}
